import Icon from '../components/Icon.vue'

Icon.register({"tint":{"width":384,"height":512,"paths":[{"d":"M192 512C93.6 512 13.9 432.3 13.9 333.9 13.9 222.7 115.1 179.8 162.4 22.1 171.5-8 213.5-6.7 221.6 22.1 269.1 180.6 370.1 222.2 370.1 333.9 370.1 432.3 290.4 512 192 512zM149.5 340.2C148 334.6 140 334.6 138.5 340.2 129.3 369.6 110.6 377.8 110.6 398.6 110.6 417.1 125.5 432 144 432S177.4 417.1 177.4 398.6C177.4 377.8 158.7 369.7 149.5 340.2z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/tint.js
// module id = null
// module chunks = 